import { Routes, Route } from 'react-router-dom'
import { AppProvider } from '@!/providers'
import { usePaymentSettings } from '@!/Hooks'
import PaymentRedirect from '@!/User/Payment/containers/PaymentRedirect'
import Restore from '@!/User/Payment/containers/MonthlyCourse/Restore'
import MonthlyCoursePaymentSelect from '@!/User/Payment/containers/MonthlyCourse/PaymentSelect'
import MonthlyCoursePaymentNewCard from '@!/User/Payment/containers/MonthlyCourse/NewCard'
import MonthlyCoursePaymentConfirm from '@!/User/Payment/containers/MonthlyCourse/PaymentConfirm'

const RestoreApp = (props) => {
  const jotaiStore = usePaymentSettings({
    isSaveLastUrl: false,
    tokenApiUrl: props.token_api_url,
    shopId: props.shop_id,
    monthlyCourses: props.monthly_courses,
  })

  return (
    <AppProvider jotaiStore={jotaiStore}>
      <Routes>
        <Route path="/" element={<Restore monthlyCourseHistory={props.monthly_course_history} />} />
        <Route path="/monthly_course/select" element={<MonthlyCoursePaymentSelect restore={true} />} />
        <Route path="/monthly_course/new_card" element={<MonthlyCoursePaymentNewCard />} />
        <Route path="/monthly_course/confirm" element={<MonthlyCoursePaymentConfirm restore={true} />} />
        <Route path="/redirect" element={<PaymentRedirect />} />
      </Routes>
    </AppProvider>
  )
}

export default RestoreApp
